import PendingAdjustmentPage from './PendingAdjustmentPage'

export default PendingAdjustmentPage
